import axios from "axios";
import { notifyForbidden } from "../utils/apiToast";
import { isHtmlString, parseApiError } from "./apiErrors";
import {
  getApiDisplayLabel,
  getMixedContentWarning,
  loadRuntimeApiConfig,
  resolveApiBaseURL,
} from "./resolveApiBase";

export { getApiDisplayLabel, loadRuntimeApiConfig };

/** @deprecated use resolveApiBaseURL — kept for existing imports */
export function getApiBaseURL() {
  return resolveApiBaseURL();
}

export function getHealthCheckUrl() {
  const base = resolveApiBaseURL();
  return base ? `${base}/api/health` : "/api/health";
}

const api = axios.create({
  baseURL: "",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  timeout: 60000,
});

api.interceptors.request.use((config) => {
  const mixed = getMixedContentWarning(resolveApiBaseURL());
  if (mixed) {
    return Promise.reject(new Error(mixed));
  }

  const base = resolveApiBaseURL();
  config.baseURL = base || "";

  if (process.env.NODE_ENV === "development") {
    const path = config.url || "";
    const url = base ? `${base}${path}` : `${window.location.origin}${path}`;
    console.debug("[API]", config.method?.toUpperCase(), url);
  }

  if (typeof FormData !== "undefined" && config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }

  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => {
    const ct = res.headers?.["content-type"] || "";
    if (typeof res.data === "string" && isHtmlString(res.data)) {
      const err = new Error(
        parseApiError({ response: { data: res.data, status: res.status } }, { apiBase: resolveApiBaseURL() })
      );
      err.isApiHtmlError = true;
      return Promise.reject(err);
    }
    if (ct && !ct.includes("application/json") && typeof res.data === "string") {
      const err = new Error("API returned a non-JSON response.");
      err.isApiHtmlError = true;
      return Promise.reject(err);
    }
    return res;
  },
  (err) => {
    const status = err?.response?.status;
    const data = err?.response?.data;

    if (typeof data === "string" && isHtmlString(data)) {
      err.message = parseApiError(err, { apiBase: resolveApiBaseURL() });
      err.isApiHtmlError = true;
    }

    if (process.env.NODE_ENV === "development") {
      console.warn("[API] error", status, err.message, err.config?.url);
    }

    if (status === 403) {
      notifyForbidden(typeof data === "object" ? data?.message : undefined);
    }
    return Promise.reject(err);
  }
);

export { parseApiError };
export default api;
